<template>
  <div id="not-single">
    <img src="~@/assets/img/not-single.png" alt="" class="img">
    <p class="tip">恭喜您脱单成功</p>
    <p class="sub">按照hello部落的用户规定，会员信息将对你不可见，同时其他会员也无法查看您的信息</p>
  </div>
</template>

<script>
export default {
  name: 'notSingle'
}
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  #not-single {
    padding: 130px 80px 20px;
    text-align: center;
    .img {
      width: 150px;
      height: 150px;
    }
    .tip {
      margin: 24px auto 30px;
      color: $mainColor;
      font-size: 28px;
      line-height: 40px;
      font-weight: bold;
    }
    .sub {
      color: #9B9B9B;
    }
  }
</style>
